import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "parent-card-title-preview" }
const _hoisted_2 = { class: "parent-card-title uppercase" }

import ResourceIcon from '@/components/elements/common/ResourceIcon';


export default /*@__PURE__*/_defineComponent({
  __name: 'ParentCardTitlePreview',
  props: {
  title: {
    type: String,
    required: false,
    default: '',
  },
  icon: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  tooltip: {
    type: String,
    required: false,
    default: '',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.icon.src)
      ? (_openBlock(), _createBlock(_unref(ResourceIcon), {
          key: 0,
          class: "w-4 h-4 mr-1",
          src: __props.icon.src || '',
          color: __props.icon.color || '',
          type: __props.icon.type || ''
        }, null, 8, ["src", "color", "type"]))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1)
  ])), [
    [_directive_tooltip, {
      content: __props.tooltip,
      placement: 'top-start',
      onShow: () => __props.tooltip !== '',
    }]
  ])
}
}

})